
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}},_vm.$listeners),[_c('path',{attrs:{"d":"M7.905 1a2.848 2.848 0 1 1-2.849 2.848 2.848 2.848 0 0 1 2.849-2.848ZM7.905 7.817c-4.028.048-7.407 3.5-5.22 5.606s8.252 2.1 10.439 0-1.219-5.561-5.219-5.606Z"}})])}
var staticRenderFns = []

    export default {
      render: render,
    }
  